const BACKEND = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (!u ? undefined : u.startsWith("http") ? u : `${BACKEND}${u}`);

const TYPE_MAP = { "full-time": "FULL_TIME", "part-time": "PART_TIME", internship: "INTERN", contract: "CONTRACTOR", remote: "FULL_TIME", temporary: "TEMPORARY" };

export const parseSalary = (s) => {
  if (!s) return undefined;
  const txt = s.toLowerCase().replace(/,/g, "");
  const nums = (txt.match(/\d+(\.\d+)?/g) || []).map(Number);
  if (!nums.length) return undefined;
  let mult = 1;
  let unit = "YEAR";
  if (/lpa|lakh/.test(txt)) mult = 100000;
  else if (/\d\s*k/.test(txt)) mult = 1000;
  if (/month|pm\b|\/m/.test(txt)) unit = "MONTH";
  const [min, max = min] = nums.map((n) => Math.round(n * mult));
  return {
    "@type": "MonetaryAmount",
    currency: "INR",
    value: { "@type": "QuantitativeValue", minValue: min, maxValue: max, unitText: unit },
  };
};

export const jobPostingLd = (j, url) => {
  const remote = /remote/i.test(`${j.type} ${j.location}`);
  const posted = new Date(j.created_at || Date.now());
  const valid = new Date(posted.getTime() + 60 * 86400000);
  const ld = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    title: j.title,
    description: `<p>${j.description || ""}</p>${(j.requirements || []).length ? `<ul>${j.requirements.map((r) => `<li>${r}</li>`).join("")}</ul>` : ""}`,
    identifier: { "@type": "PropertyValue", name: "Classroom to Corporate", value: j.job_id },
    datePosted: posted.toISOString().slice(0, 10),
    validThrough: valid.toISOString(),
    employmentType: TYPE_MAP[(j.type || "").toLowerCase()] || "FULL_TIME",
    hiringOrganization: { "@type": "Organization", name: j.company, logo: abs(j.company_logo) },
    directApply: true,
    url,
    baseSalary: parseSalary(j.salary),
  };
  if (remote) {
    ld.jobLocationType = "TELECOMMUTE";
    ld.applicantLocationRequirements = { "@type": "Country", name: "India" };
  } else {
    const [locality, ...rest] = (j.location || "").split(",").map((x) => x.trim());
    ld.jobLocation = {
      "@type": "Place",
      address: { "@type": "PostalAddress", addressLocality: locality, addressRegion: rest[0] && rest[0] !== "India" ? rest[0] : undefined, addressCountry: "IN" },
    };
  }
  return ld;
};
